import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const SidebarWrapper = styled(Box)<{ open?: boolean }>`
  transition: all 0.3s ease;
  width: 260px;
  overflow: hidden;
  @media (max-width: 1200px) {
    width: ${({ open }) => (open ? '260px' : '0')};
  }
`

export const SidebarFooter = styled(Box)`
  border-top: 1px solid ${({ theme }) => getThemeColor('grey_4', theme)};
`

export const SidebarFooterText = styled(Text)`
  p {
    font-size: 12.5px;
  }
  opacity: 0.8;
`
